import { HqApiService } from 'hq/services/hqApiService';
import { Site } from 'shared/hooks';
import { PaymentInfiniteResponse, paymentInfiniteResponseSchema } from './payments.schema';

export class PaymentsService {
  constructor(private readonly hqApiService: HqApiService) {}
  public async getPaginatedPayments(site: Site, page: number, pageSize: number) {
    const response = await this.getPaginatedPaymentsImpl(site, page, pageSize);
    return paymentInfiniteResponseSchema.parse(response);
  }
  private async getPaginatedPaymentsImpl(site: Site, page: number, pageSize: number) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.get<PaymentInfiniteResponse>({
          path: `payments`,
          params: {
            page,
            pageSize,
          },
        });
      default:
        throw new Error('Not implemented');
    }
  }
}
